import { useQuery } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { useEffect } from 'react';

import { apiUrlGenerator } from '../use-api';
import { showResult } from '../utils';

import type { ISmsCampaignOutcomesData } from 'infrastructure/interfaces';

const queryFn = async (token: string | null) => {
  const url = 'core-2/patients/sms-campaign/outcomes';
  const { data, error } = await dataService.getList<ISmsCampaignOutcomesData>(
    apiUrlGenerator(url, { token }),
  );

  if (error) {
    return Promise.reject(error);
  }

  return data;
};

export const useGetCampaignOutcomeData = (token: string | null) => {
  const { data, isLoading, error, isError } = useQuery<
    ISmsCampaignOutcomesData | undefined,
    string | undefined
  >({
    queryKey: ['getSmsCampaignOutcomeData'],
    queryFn: () => queryFn(token),
    enabled: Boolean(token),
  });

  useEffect(() => {
    if (error) {
      showResult(error);
    }
  }, [error]);

  return { data, isLoading, isError };
};
